import { $, addAction } from '@situation/setdesign.util';

function processDeferredContent(_index, element) {
    const $element = $(element);
    const decodedContent = atob($element.data('deferredContent'));
    element.removeAttribute('data-deferred-content');
    $element.html(decodedContent);
    $element.find('iframe').attr('width', '100%');
}

addAction('showModal', ($modal) => {
    $modal.find('[data-deferred-content]').each(processDeferredContent);
});
